// src/utils/companyOverview.js
//
// Resumen de UNA compañía para su P.A Admin: cuánto se cobró en cheques, cuánto le
// toca a sus P.A, cuánto le corresponde a CSR y cuánto le falta por pagarle a CSR
// (su deuda). CSR gana un % sobre la parte del P.A (claimService: csrCollected /
// totalCollected), por eso "deuda con CSR" = lo pendiente de ese cobro.
// Funciones puras: reciben los cheques y reclamos ya cargados de la compañía.

const num = value => Number(value) || 0;
const round = value => Math.round(value * 100) / 100;

const adjusterGross = check => (num(check.amount) * num(check.adjusterPercentage)) / 100;

export const summarizeChecks = (checks = []) => {
  const amount = checks.reduce((sum, c) => sum + num(c.amount), 0);
  const paGross = checks.reduce((sum, c) => sum + adjusterGross(c), 0);
  const csrOwed = checks.reduce((sum, c) => sum + num(c.totalCollected), 0);
  const csrPaid = checks.reduce((sum, c) => sum + num(c.deposit), 0);
  const csrPending = checks.reduce((sum, c) => sum + num(c.pending), 0);
  return {
    checks: checks.length,
    amount: round(amount),
    paGross: round(paGross),
    csrOwed: round(csrOwed),
    csrPaid: round(csrPaid),
    csrPending: round(csrPending),
    paNet: round(paGross - csrOwed)
  };
};

// Un renglón por P.A (el principal del cheque), de mayor a menor deuda con CSR.
export const companyOverview = (checks = [], claimRecords = []) => {
  const byAdjuster = new Map();
  checks.forEach(check => {
    const name = check.adjusterName || '—';
    if (!byAdjuster.has(name)) byAdjuster.set(name, []);
    byAdjuster.get(name).push(check);
  });
  const claimsByAdjuster = new Map();
  claimRecords.forEach(record => {
    const name = record.adjusterName || '—';
    claimsByAdjuster.set(name, (claimsByAdjuster.get(name) || 0) + 1);
  });
  const names = new Set([...byAdjuster.keys(), ...claimsByAdjuster.keys()]);
  const adjusters = [...names].map(name => ({
    name,
    claims: claimsByAdjuster.get(name) || 0,
    ...summarizeChecks(byAdjuster.get(name) || [])
  })).sort((a, b) => b.csrPending - a.csrPending || a.name.localeCompare(b.name));
  return { claims: claimRecords.length, ...summarizeChecks(checks), adjusters };
};
